import { render } from "./CurveSection.vue?vue&type=template&id=000c357a&scoped=true"
import script from "./CurveSection.vue?vue&type=script&lang=js"
export * from "./CurveSection.vue?vue&type=script&lang=js"

import "./CurveSection.vue?vue&type=style&index=0&id=000c357a&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000c357a"]])

export default __exports__